import React from 'react';
import { Globe } from 'lucide-react';

interface Step7Data {
  website_url: string;
}

interface Step7WebsiteProps {
  data: Step7Data;
  onChange: (data: Step7Data) => void;
}

export function Step7Website({ data, onChange }: Step7WebsiteProps) {
  const [noWebsite, setNoWebsite] = React.useState(false);

  const handleCheckboxChange = (checked: boolean) => {
    setNoWebsite(checked);
    if (checked) {
      onChange({ ...data, website_url: '' });
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
          <Globe className="w-4 h-4" />
          Heb je een website die we kunnen bekijken?
        </label>
        <input
          type="url"
          value={data.website_url}
          onChange={(e) => onChange({ ...data, website_url: e.target.value })}
          disabled={noWebsite}
          className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-lg disabled:bg-gray-100 disabled:cursor-not-allowed"
          placeholder="www.bakkerij-korenbloem.nl"
          autoFocus={!noWebsite}
        />
      </div>

      <div className="flex items-center gap-2">
        <input
          type="checkbox"
          id="no-website"
          checked={noWebsite}
          onChange={(e) => handleCheckboxChange(e.target.checked)}
          className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
        />
        <label htmlFor="no-website" className="text-sm text-gray-700 cursor-pointer">
          Ik heb (nog) geen website
        </label>
      </div>
    </div>
  );
}
